<template>
  <article class="columns is-multiline is-variable is-2 is-vcentered">
    <div class="column is-2 is-4-tablet is-2-desktop">
      <p class="image">
        <img
          :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=150&quality=50&interlace=true&type=auto&file=${item.image}`"
          :srcset="
            `https://assets.urlaubsgutschein.kaufen/i/resize?width=150&quality=50&interlace=true&type=auto&file=${item.image} 150w,
                      https://assets.urlaubsgutschein.kaufen/i/resize?width=300&quality=50&interlace=true&type=auto&file=${item.image} 300w,
                      https://assets.urlaubsgutschein.kaufen/i/crop?width=700&height=300&gravity=smart&quality=50&interlace=true&type=auto&file=${item.image} 700w`
          "
          sizes="(max-width: 768px) 100vw,
                   10vw"
          :alt="item.title"
          loading="lazy"
          importance="low"
        />
      </p>
    </div>
    <div class="column is-7 is-8-tablet is-7-desktop">
      <div class="has-text-weight-semibold">{{ item.title }}</div>
      <p class="u-text--ellipsis">
        <small>{{ item.subtitle }}</small>
      </p>
      <div class="u-text--ellipsis">
        <small>{{ item.description }}</small>
      </div>
      <!-- VERSICHERUNG  START -->
      <div class="columns is-vcentered is-mobile is-gapless c-cartdrawer_itemoptions is-multiline" v-for="upgrade in item.upgrades" :key="upgrade.id">
        <div class="column is-8-tablet is-7-mobile is-size-7">{{ upgrade.description }} ({{ item.currency | currency }} {{ upgrade.unitPrice | amount }})</div>
      </div>
      <!-- VERSICHERUNG  END -->
    </div>
    <div class="column is-3 is-12-tablet is-3-desktop has-text-right">
      <strong class="is-size-5">{{ item.currency | currency }} {{ item.total | amount }}</strong>
      <br />
      <small class="is-size-6"
        >{{ item.quantity }} {{ $t('general.piece') }} <span class="is-inline-block">à {{ item.currency | currency }} {{ item.unitPrice | amount }}</span></small
      >
    </div>
  </article>
</template>

<script>
export default {
  name: 'OrderArticle',
  props: {
    item: Object,
  },
}
</script>
